/*! React Starter Kit | MIT License | http://www.reactstarterkit.com/ */

import React from 'react'; // eslint-disable-line no-unused-vars
import PropTypes from 'prop-types';
import styles from './CommercialOffers.scss';
import datePickerCss from '../../../node_modules/react-datepicker/dist/react-datepicker.min.css';
import BaseReactComponent from '../Util/BaseReactComponent';
import baseComponent from '../../decorators/baseComponent';
import Offer from './Offer';
import CountryList from '../Util/CountryList';


@baseComponent(datePickerCss)
@baseComponent(styles) class CommercialOffers extends BaseReactComponent {

  constructor(props) {
    super(props);

    this.state = {};
    this.state.offers = [];
    this.state.offersChanged = new Set();
  }


  componentDidMount() {
    this.updateOffers(this.props);
  }

  componentWillReceiveProps(nextProps) {
    this.updateOffers(nextProps);
  }

  updateOffers(props) {
    let commercialOffers = CountryList.map(function (c) {
      let offer = props.commercialOffers.find((element) => element.country === c.id);

      if (offer) {
        return offer;
      } else {
        offer = {};
        offer.country = c.id;
        offer.activationDate = '';
        offer.endOfLifeDate = '';
        offer.url = '';
      }

      return offer;
    });

    this.setState({
      offers: commercialOffers
    });
  }

  handleOfferChanged(offer) {
    let index = this.state.offers.findIndex((element) => element.country === offer.country);

    this.state.offers[index] = offer;

    this.state.offersChanged.add(index);
  }

  save() {
    let self = this;

    self.state.offersChanged.forEach(function (index) {
      self.props.saveCommercialOffer(self.state.offers[index]);
    });

  }

  render() {
    let subTitle = this.getMessage('title');

    let self = this;

    let commercialOffers = this.state.offers.map(function (c, i) {
      return <Offer key={i} commercialOffer={c} saveCommercialOffer={self.save.bind(self)} handleOfferChanged={self.handleOfferChanged.bind(self)}/>;
    });

    return (
      <div className="CommercialOffers">
        <div className="editor-header">
          <div className="container">
            <h1>{subTitle}</h1>
          </div>
        </div>

        <div className="container">
          <form>
            {commercialOffers}
            <a className="btn btn-primary save-button" onClick={this.save.bind(this)}>{this.getMessage('save-button')}</a>
          </form>
        </div>
      </div>
    );
  }
}

CommercialOffers.PropTypes = {
  commercialOffers: React.PropTypes.array,
  saveCommercialOffer: React.PropTypes.func
};

CommercialOffers.defaultProps = {
  componentName: 'commercial-offers'
};

export default CommercialOffers;



// WEBPACK FOOTER //
// /src/components/CommercialOffers/CommercialOffers.js